// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"142":"af75e9adbb","945":"92460c7853","948":"2cb01ee62c"}[chunkId] + ".css";
};